import { useState, useEffect } from 'react';
import {
    createTypeCategories,
    deleteTypeCategories,
    getTypeCategories,
    getTypeCategoriesById,
    updateTypeCategories,
    updateActive
} from '../services/TypeProductService';
import useAlert from '../../../shared/hooks/useAlert';

const useTypeProduct = () => {


    const [typeProduct, setTypeProduct] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { alert, showAlert } = useAlert();

    const fetchTypeProduct = async () => {
        setLoading(true);
        try {
            const response = await getTypeCategories();
            setTypeProduct(response.data);
        } catch (err) {
            setError('Failed to fetch categories');
        } finally {
            setLoading(false);
        }
    };

    const fetchTypeProductById = async (id) => {
        try {
            const response = await getTypeCategoriesById(id);
            setTypeProduct(typeProduct.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update typeProduct');
        }
    };

    const addTypeProduct = async (typeProduct) => {
        try {
            await createTypeCategories(typeProduct);
            // setTypeProduct([...typeProduct, response.data]);
            fetchTypeProduct();
            showAlert('Created successfully!', 'success');
        } catch {
            setError('Failed to add categories');
            showAlert('Error creating', 'danger');
        }
    };

    const editTypeProduct = async (id, updatedTypeProduct) => {
        try {
            const response = await updateTypeCategories(id, updatedTypeProduct);
            
            setTypeProduct(typeProduct.map(p => (p.id === id ? response.data : p)));
            fetchTypeProduct();
            showAlert('Edited successfully!', 'success');
        } catch {
            setError('Failed to update categories');
            showAlert('Error creating', 'danger');
        }
    };

    const updateOnActive = async (id, updatedStatus) => {
        try {
            const response = await updateActive(id, updatedStatus);
            setTypeProduct(typeProduct.map(p => (p.id === id ? response.data : p)));
            showAlert('Edited successfully!', 'success');
        } catch {
            setError('Failed to update categories');
            showAlert('Error creating', 'danger');
        }
    };

    const removeTypeProduct = async (id) => {
        try {
            await deleteTypeCategories(id);
            setTypeProduct(typeProduct.filter(p => p.id !== id));
            showAlert('Remove successfully!', 'success');
        } catch {
            setError('Failed to delete categories');
            showAlert('Error creating', 'danger');
        }
    };

    useEffect(() => {
        fetchTypeProduct();
    }, []);

    return {
        typeProduct,
        loading,
        error,
        fetchTypeProduct,
        addTypeProduct,
        editTypeProduct,
        fetchTypeProductById,
        removeTypeProduct,
        updateOnActive,
        alert
    };
}

export default useTypeProduct;
